// eslint-disable-next-line
// @ts-nocheck

import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import Loading from '../../components/Loading';
import toast from 'react-hot-toast';
import { useFindUsersByCategoryMutation, useForgotPasswordMutation } from '../../store/api/userApi';
import { getUserDetails, getUserTotalRecords, setUser } from '../../store/state/userSlice';
import { checkPermissions, onlyLastEmailShow, onlyLastFourNum } from '../../sections/@dashboard/parkingspaces/utility';
import { getMessage } from '../../components/message';
import { PERMISSION } from '../../utils/userPermission';
import IconButton from '@mui/material/IconButton';
import LockResetIcon from '@mui/icons-material/LockReset';
import Tooltip from '@mui/material/Tooltip';

const TABLE_HEAD = [
  { id: 'name', label: 'Username', alignRight: false },
  { id: 'emailId', label: 'Email Address', alignRight: false },
  { id: 'contactNumber', label: 'Phone Number', alignRight: false },
  { id: 'role', label: 'User Role', alignRight: false },
  { id: 'resetPassword', label: 'Reset Password', alignRight: false },
];

export default function UserManagement() {
  const navigate = useNavigate();
  const localUserObj = JSON.parse(localStorage.getItem('login') || '{}');
  const [forgetPassword, forgetPasswordResponse] = useForgotPasswordMutation();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const userData = useAppSelector(getUserDetails);
  const userTotalRecords = useAppSelector(getUserTotalRecords);
  const [userDatas, setUserDatas] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [findByUser, findByUserResponse] = useFindUsersByCategoryMutation();
  const filteredUsers = userDatas;
  const isUserNotFound = filteredUsers.length === 0;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  useEffect(() => {
    findByUser({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        userCategory: localUserObj.userType === 'UTSA' ? ['UTSA'] : ['UTSP'],
        serviceProviderId: localUserObj?.serviceProviderId ? localUserObj?.serviceProviderId : '',
      },
    });
    setFilterName('');
  }, []);

  useEffect(() => {
    if (findByUserResponse.isSuccess) {
      dispatch(setUser(findByUserResponse.data));
    }
  }, [findByUserResponse.isSuccess]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = userDatas.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  useEffect(() => {
    if (userData) {
      setUserDatas(userData);
    }
  }, [userData]);

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    await findByUser({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: newPage,
        userCategory: localUserObj.userType === 'UTSA' ? ['UTSA'] : ['UTSP'],
        serviceProviderId: localUserObj?.serviceProviderId ? localUserObj?.serviceProviderId : '',
      },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    findByUser({
      token: token.token,
      payload: {
        offset: parseInt(event.target.value, 10),
        page: page,
        userCategory: localUserObj.userType === 'UTSA' ? ['UTSA'] : ['UTSP'],
        serviceProviderId: localUserObj?.serviceProviderId ? localUserObj?.serviceProviderId : '',
      },
    });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    findByUser({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        userCategory: ['UTSA'],
        userCategory: localUserObj.userType === 'UTSA' ? ['UTSA'] : ['UTSP'],
        serviceProviderId: localUserObj?.serviceProviderId ? localUserObj?.serviceProviderId : '',
        searchValue: event.target.value,
      },
    });
  };

  const handleClick = (email: any, categoryTypeId: any) => {
    forgetPassword({
      email: email,
      category: categoryTypeId,
    });
  };

  useEffect(() => {
    if (forgetPasswordResponse.isSuccess) {
      toast.success(getMessage.SUCCESS_FORGOT_PASSWORD);
    }
    if (forgetPasswordResponse.isError) {
      toast.error(getMessage.Error_FORGOT_PASSWORD);
    }
  }, [forgetPasswordResponse.isSuccess, forgetPasswordResponse.isError]);

  function capitalizeFirstLetter(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  

  return (
    <Page title="User Management">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            User Management
          </Typography>
          {checkPermissions(PERMISSION.USER_MGMT_ADD, token.permissions) && (
            <Button
              style={{
                color: 'white',
                backgroundColor: '#E23744',
              }}
              variant="contained"
              onClick={() => {
                navigate('/dashboard/add-user', { state: { editMode: false } });
              }}
              startIcon={<Iconify icon="eva:plus-fill" />}
              size="large"
            >
              Add
            </Button>
          )}
        </Stack>
        <Card>
          <BookingListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            placeholder={'Search By Username'}
          />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={userDatas.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const {
                        id,
                        name,
                        email,
                        mobileNo,
                        userId,
                        tierType,
                        commission,
                        merchantId,
                        roleIdName,
                        categoryTypeId,
                      } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;
                      return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">
                            <Typography
                              fontWeight="bold"
                              variant="subtitle2"
                              whiteSpace={'nowrap'}
                              style={{
                                color: checkPermissions(PERMISSION.USER_MGMT_HIDE_DETAIL, token.permissions)
                                  ? ''
                                  : 'blue',
                                cursor: checkPermissions(PERMISSION.USER_MGMT_HIDE_DETAIL, token.permissions)
                                  ? 'cursor-text'
                                  : 'pointer',
                              }}
                              onClick={() => {
                                if (!checkPermissions(PERMISSION.USER_MGMT_HIDE_DETAIL, token.permissions)) {
                                  navigate('/dashboard/add-user', {
                                    state: {
                                      id: id,
                                      merchantId: merchantId,
                                      commission: commission,
                                      tierType: tierType,
                                      userId: userId,
                                      editMode: true,
                                    },
                                  });
                                }
                              }}

                            >
                              {capitalizeFirstLetter(name)}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="normal" variant="subtitle2">
                              {checkPermissions(PERMISSION.USER_MGMT_HIDE_DETAIL, token.permissions)
                                ? onlyLastEmailShow(email)
                                : email}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="normal" variant="subtitle2">
                              {checkPermissions(PERMISSION.USER_MGMT_HIDE_DETAIL, token.permissions)
                                ? onlyLastFourNum(mobileNo)
                                : mobileNo}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Typography fontWeight="normal" variant="subtitle2">
                              {roleIdName.map((value, index) => {
                                return (
                                  <p key={index}>
                                    {value} {index < roleIdName.length - 1 ? ', ' : ''}
                                  </p>
                                );
                              })}
                            </Typography>
                          </TableCell>

                          <TableCell align="center">
                            <Tooltip title="Reset Password">
                            <IconButton
                              onClick={() => handleClick(email, categoryTypeId)}
                              style={{ color: '#E23744' }}
                              disabled={
                                !checkPermissions(PERMISSION.USER_MGMT_RESET_PASSWORD, token.permissions)
                              }
                            >
                              <LockResetIcon />
                            </IconButton>
                          </Tooltip>

                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={userTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {findByUserResponse.isLoading ? <Loading /> : null}
      </Container>
    </Page>
  );
}
